import { Button, TextField } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Box from "elements/Box";
import { ProjectConfig } from "Global";
import { useSnackbar, withSnackbar } from "notistack";
import LangTabs from "elements/LangTabs";

export default withSnackbar(function RitualesCategoryEditor(props: any) {
  const { enqueueSnackbar } = useSnackbar();
  let { rituales_category_id } = useParams();
  const navigate = useNavigate();

  const defaultValues: any = {
    rituales_category_id: rituales_category_id ? rituales_category_id : "null",
    title: "",
  };

  const [loading, setLoading] = useState(false);
  const [formValues, setFormValues] = useState(defaultValues);

  // i18n: idioma actual y traducciones
  const [currentLangId, setCurrentLangId] = useState<string>("1");
  const [translations, setTranslations] = useState<Record<string, any>>({});

  // Handler para cambio de idioma
  const handleLangChange = (newLangId: string) => {
    setCurrentLangId(newLangId);
  };

  // Helper para obtener el título según idioma
  const getCurrentTitle = () => {
    if (currentLangId === "1") return formValues.title || "";
    return translations[currentLangId]?.title || "";
  };

  // Helper para actualizar traducciones
  const updateTranslation = (field: string, value: any) => {
    setTranslations(prev => ({
      ...prev,
      [currentLangId]: {
        ...prev[currentLangId],
        [field]: value
      }
    }));
  };

  // Handler para cambio de título
  const handleTitleChange = (e: { target: { value: any } }) => {
    const value = e.target.value;
    if (currentLangId === "1") {
      setFormValues({ ...formValues, title: value });
    } else {
      updateTranslation('title', value);
    }
  };

  /*=======================================
    GET DETAILS IF EDITING
  =======================================*/
  useEffect(() => {
    if (rituales_category_id) {
      axios
        .get(ProjectConfig.api_url, {
          params: {
            request: "rituales_category_details",
            id: rituales_category_id,
          },
        })
        .then((response) => {
          setFormValues(response.data);
          if (response.data.translations) {
            setTranslations(response.data.translations);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [rituales_category_id]);

  /*=======================================
    SUBMIT
  =======================================*/
  const [progress, setProgress] = useState(0);

  const handleSubmit = () => {
    setLoading(true);

    // Preparar formValues con traducciones
    const formValuesWithTranslations = {
      ...formValues,
      translations: translations
    };

    axios
      .post(ProjectConfig.api_url, null, {
        params: {
          request: "add_edit_rituales_categorias",
          formValues: JSON.stringify(formValuesWithTranslations),
        },
      })
      .then((response) => {
        if (response.data) {
          enqueueSnackbar("Categoría guardada exitosamente", { variant: "success" });
          navigate("/admin/ritos/categorias");
        } else {
          enqueueSnackbar("Error al guardar", { variant: "error" });
        }
      })
      .catch((err) => {
        console.log(err.data);
        enqueueSnackbar("Error al guardar", { variant: "error" });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div id="userForm">
      <div id="task_form_container" className="flex_container">
        <Box
          id="user_form"
          title="Categoría de Rito"
          subtitle={rituales_category_id ? "Editar" : "Agregar"}
        >
          {/* Tabs de idioma */}
          <LangTabs currentLangId={currentLangId} onChange={handleLangChange} />

          {/* Campo de Título */}
          <TextField
            required
            fullWidth
            id="title"
            name="title"
            label="Título de la Categoría"
            value={getCurrentTitle()}
            onChange={handleTitleChange}
            style={{ marginTop: "20px" }}
          />

          {/* Botones de acción */}
          <div className="form_buttons">
            <Button
              variant="outlined"
              onClick={() => navigate("/admin/ritos/categorias")}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Guardando..." : "Guardar"}
            </Button>
          </div>
        </Box>
      </div>
    </div>
  );
});
